import { parseJSON } from "date-fns/fp";
import * as R from "remeda";

// const isPrimitive = () => {
//     return [R.isBoolean, R.isNumber, R.isNil, R.isString].some()
// }

class Odeon {
    private ObjectId: any;
    constructor(ObjectId: any) {
        this.ObjectId = ObjectId;
    }
    toOdeon = (object: any): any => {
        if (object instanceof Date) {
            return {
                __TYPE__: "DATE",
                value: object,
            };
        }

        if (object instanceof this.ObjectId) {
            return {
                __TYPE__: "OBJECT_ID",
                value: object,
            };
        }

        if (Array.isArray(object)) {
            return object.map(this.toOdeon);
        }

        if (typeof object === "object" && object !== null) {
            return R.mapValues(object, this.toOdeon);
        }

        return object;
    };

    fromOdeon = (object: any): any => {
        if (object === null) {
            return null;
        }

        if (
            !Array.isArray(object) &&
            typeof object === "object" &&
            "__TYPE__" in object
        ) {
            if (object["__TYPE__"] === "OBJECT_ID") {
                return new this.ObjectId(object.value);
            }
            if (object["__TYPE__"] === "DATE") {
                return parseJSON(object.value);
            }
        }

        if (Array.isArray(object)) {
            return object.map(this.fromOdeon);
        }

        if (typeof object === "object") {
            return R.mapValues(object, this.fromOdeon);
        }

        return object;
    };
}

export default Odeon;
